export type SubscriberBadgeVariant =
  | "default"
  | "secondary"
  | "destructive"
  | "outline";

const STATUS_LABELS: Record<string, string> = {
  subscribed: "Subscribed",
  welcome_sent: "Welcomed",
  welcome_failed: "Welcome failed",
  bounced: "Bounced",
  complained: "Complained",
  unsubscribed: "Unsubscribed",
};

export function subscriberStatusLabel(status?: string | null): string {
  if (!status) return "Unknown";
  return STATUS_LABELS[status] ?? status;
}

// Statuses in which the person has withdrawn marketing consent. A bounce is a
// deliverability problem, not a withdrawal.
const CONSENT_WITHDRAWN = new Set(["unsubscribed", "complained"]);

/** True while a mail-list row still grants consent to marketing email. */
export function subscriberHasMarketingConsent(status?: string | null): boolean {
  return Boolean(status) && !CONSENT_WITHDRAWN.has(status as string);
}

export function subscriberStatusBadgeVariant(
  status?: string | null,
): SubscriberBadgeVariant {
  switch (status) {
    case "welcome_sent":
      return "default";
    case "welcome_failed":
    case "bounced":
    case "complained":
      return "destructive";
    case "unsubscribed":
      return "outline";
    default:
      return "secondary";
  }
}
